import React from 'react'

import gift from '../../../../assets/images/gift.svg'
import Alert from '../../feedback/Alert'

type DiscountAlertProps = {
  message?: string
  description?: string
}
const DiscountAlert = ({ message, description }: DiscountAlertProps) => (
  <Alert
    className={'t-admin-signup-discount-message'}
    type="success"
    showIcon
    icon={<img src={gift} alt="gift-icon" />}
    message={message ?? 'Your discount has been applied!'}
    description={description}
  />
)

export default DiscountAlert
